const host = process.env.BASE_SERVER_URL
const wsHost = process.env.BASE_WEBSOCKET_URL
const picUrl = process.env.PIC_URL
export default {
  host,
  wsHost,
  picUrl
}



//////////////////
// WEBPACK FOOTER
// ./static/config/global.js
// module id = null
// module chunks = 